/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { bool, string, node, shape } from "prop-types";
import Col from "react-bootstrap/lib/Col";
import { push } from "react-router-redux";
import { Field, Form, withFormik } from "formik";
import Yup from "yup";

import Button from "pages/_components/Button";
import { DateField } from "pages/_components/fields/DateField";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";

import { actions as transactionsActions } from "reducers/transactions";

import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import { evalEqualsValues } from "util/form";
import classNames from "classnames";
import { normalizeActivityId } from "util/transaction";

const FORM_ID = "transactions.list.filters.period";

class PeriodFilterPendingTransactions extends Component {
    static propTypes = {
        fetching: bool,
        buttonLabel: string,
        cleanFiltersButton: node,
        renderOrder: node,
        dateFrom: string,
        dateTo: string,
        isMobileMvp3: bool,
        values: shape({}),
        selectedFilter: string,
        idActivity: string,
        filters: shape({}),
    };

    static defaultProps = {
        fetching: false,
        buttonLabel: null,
        cleanFiltersButton: null,
        renderOrder: null,
        dateFrom: null,
        dateTo: null,
        isMobileMvp3: false,
        values: {},
        selectedFilter: null,
        idActivity: null,
        filters: {},
    };

    render() {
        const {
            fetching,
            dateFrom,
            dateTo,
            buttonLabel,
            cleanFiltersButton,
            renderOrder,
            values,
            selectedFilter,
            idActivity,
            filters,
            isMobileMvp3,
        } = this.props;

        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const buttonSection = (
            <Col
                sm={12}
                md={3}
                lg={3}
                className={classNames("d-flex f-dir-col mt-35 pt-3 position-relative", {
                    "pl-3": !isMobileMvp3,
                    "pl-0": isMobileMvp3,
                    "pr-0": isMobileMvp3,
                    "pr-3": !isMobileMvp3,
                })}>
                <Button
                    bsStyle="primary"
                    label={buttonLabel || "product.filters.filter"}
                    loading={fetching}
                    type="submit"
                    image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                    imageStyle="mr-2"
                    className={classNames("filter-button m-0 w-100", {
                        "text-transform-none": enableNewSubmitButton,
                    })}
                    disabled={
                        enableNewSubmitButton &&
                        (!selectedFilter ||
                            evalEqualsValues(
                                {
                                    ...filters,
                                    searchBy: filters.filter,
                                },
                                {
                                    ...values,
                                    idActivity,
                                    searchBy: selectedFilter,
                                },
                                [
                                    ...(!enableRangeDatefield ? ["dates"] : []),
                                    ...(enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                ],
                                [
                                    ...(enableRangeDatefield ? ["dates"] : []),
                                    ...(!enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                ],
                            ))
                    }
                />
                {isMobileMvp3 ? (
                    cleanFiltersButton
                ) : (
                    <div className="pending-transactions__clean-filters-absolute">{cleanFiltersButton}</div>
                )}
            </Col>
        );

        const orderSection = (
            <Col
                sm={12}
                md={3}
                lg={3}
                className={classNames("d-flex f-dir-col px-0", {
                    "pl-3": !isMobileMvp3,
                })}>
                {renderOrder}
            </Col>
        );

        const periodSection = enableRangeDatefield ? (
            <Col
                sm={12}
                md={6}
                lg={6}
                className={classNames("mt-15", {
                    "pl-0": isMobileMvp3,
                    "pr-0": isMobileMvp3,
                })}>
                <Field
                    component={RangeDatePicker}
                    idForm={FORM_ID}
                    name="dates"
                    maxDate={new Date()}
                    className="height-48"
                />
            </Col>
        ) : (
            <>
                <Col
                    sm={12}
                    md={3}
                    lg={3}
                    className={classNames("period-filter__periods", {
                        "pl-0": isMobileMvp3,
                        "pr-0": isMobileMvp3,
                    })}>
                    <Field
                        idForm={FORM_ID}
                        idField="dateFromPeriodFilter"
                        name="dateFrom"
                        component={DateField}
                        maxDate={dateTo}
                        value={dateFrom}
                        hidePlaceholder
                        selectsStart
                    />
                </Col>
                <Col
                    sm={12}
                    md={3}
                    lg={3}
                    className={classNames("period-filter__periods", {
                        "pl-0": isMobileMvp3,
                        "pr-0": isMobileMvp3,
                    })}>
                    <Field
                        idForm={FORM_ID}
                        idField="dateToPeriodFilter"
                        name="dateTo"
                        component={DateField}
                        minDate={dateFrom}
                        maxDate={new Date()}
                        value={dateTo}
                        hidePlaceholder
                        selectsEnd
                    />
                </Col>
            </>
        );

        return (
            <Form autoComplete="off">
                {isMobileMvp3 ? (
                    <>
                        {orderSection}
                        {periodSection}
                        {buttonSection}
                    </>
                ) : (
                    <>
                        {buttonSection}
                        {orderSection}
                        {periodSection}
                    </>
                )}
            </Form>
        );
    }
}

export default withFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    mapPropsToValues: (props) => {
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        return enableRangeDatefield
            ? {
                  dates: [props.dateFrom || null, props.dateTo || null],
              }
            : {
                  dateFrom: props.dateFrom ? props.dateFrom : null,
                  dateTo: props.dateTo ? props.dateTo : null,
              };
    },
    validationSchema: () =>
        Yup.lazy((values) =>
            Yup.object().shape({
                dateFrom: values.dateTo
                    ? Yup.date()
                          .nullable()
                          .max(values.dateTo, i18n.get("accounts.movements.filters.from.error"))
                    : Yup.date().nullable(),
                dateTo: values.dateFrom
                    ? Yup.date()
                          .nullable()
                          .min(values.dateFrom, i18n.get("accounts.movements.filters.to.error"))
                    : Yup.date().nullable(),
            }),
        ),
    handleSubmit: ({ dates, ...filters }, formikBag) => {
        const {
            dispatch,
            isDesktop,
            onlyPendings,
            pendingDispatch,
            dateType,
            status,
            idActivity,
            cleanSelectedRows,
            filters: reduxFilters,
        } = formikBag.props;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const normalizedIdActivity = normalizeActivityId(idActivity);

        if (cleanSelectedRows) {
            cleanSelectedRows();
        }
        if (isDesktop) {
            dispatch(
                transactionsActions.loadListRequest(
                    {
                        ...(reduxFilters || {}),
                        ...filters,
                        ...(enableRangeDatefield && {
                            dateFrom: dates[0],
                            dateTo: dates[1],
                        }),
                        dateType,
                        status,
                        idActivity: normalizedIdActivity,
                        filter: "creationDate",
                        pageNumber: 1,
                    },
                    onlyPendings,
                    pendingDispatch,
                    "",
                    formikBag,
                ),
            );
        } else {
            dispatch(
                transactionsActions.setFilters({
                    ...(reduxFilters || {}),
                    filter: "period",
                    ...filters,
                    ...(enableRangeDatefield && {
                        dateFrom: dates[0],
                        dateTo: dates[1],
                    }),
                    pageNumber: 1,
                }),
            );
            dispatch(push(`/transactions/list/filters/results`));
        }
    },
})(PeriodFilterPendingTransactions);
